import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import SellDeliveryNoteStatusBar, { SellDeliveryNoteStatusBarNew, SellDeliveryNoteStatusBarProps } from '../../../SellDeliveryNStatusBar'
import SellDeliveryNoteCreateStepButtons, { SellDeliveryNoteCreateStepButtonsNew } from '../SellDeliveryNoteCreateStepButtons'

type SellDeliveryNoteCreateStepHeaderProps = & SellDeliveryNoteStatusBarProps & OrderStepButtonsBaseComponentProps

const SellDeliveryNoteCreateStepHeaderDecider: React.FC<SellDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellDeliveryNoteCreateStepHeaderDefault} NewComponent={SellDeliveryNoteCreateStepHeaderNew} {...rest} />
    )
}

const SellDeliveryNoteCreateStepHeaderDefault: React.FC<SellDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellDeliveryNoteStatusBar {...rest} />
            <SellDeliveryNoteCreateStepButtons {...rest} />
        </div>
    )
}

const SellDeliveryNoteCreateStepHeaderNew: React.FC<SellDeliveryNoteCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellDeliveryNoteStatusBarNew {...rest} />
            <SellDeliveryNoteCreateStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellDeliveryNoteCreateStepHeaderDecider